"use strict";
import React, { cloneElement, Children, Component, createRef } from "react";
import classNames from "classnames";
import ReactResizeDetector from "react-resize-detector/build/withPolyfill";
import { withTabs } from "./Tabs";
export var TabListAlign = /* @__PURE__ */ ((TabListAlign2) => {
  TabListAlign2["Start"] = "start";
  TabListAlign2["Center"] = "center";
  TabListAlign2["End"] = "end";
  return TabListAlign2;
})(TabListAlign || {});
class TabList extends Component {
  constructor() {
    super(...arguments);
    this.tabListRef = createRef();
    this.getIndicatorRect = () => {
      const { selectedIndex, tabRefs } = this.props.tabs;
      const tabListRect = this.tabListRef.current?.getBoundingClientRect();
      const selected = selectedIndex != null ? tabRefs[selectedIndex] : void 0;
      const selectedTabRect = selected?.current?.getBoundingClientRect();
      const selectedTabRectLeft = selectedTabRect ? selectedTabRect.left : 0;
      const tabListScrollLeft = this.tabListRef.current ? this.tabListRef.current.scrollLeft : 0;
      const tabListRectLeft = tabListRect ? tabListRect.left : 0;
      const left = selectedTabRectLeft + tabListScrollLeft - tabListRectLeft;
      const width = selectedTabRect?.width || 0;
      return { left, width };
    };
    this.updateIndicator = () => {
      const indicatorRect = this.getIndicatorRect();
      this.props.tabs.setIndicator(indicatorRect);
    };
    this.handleKeyDown = (event) => {
      const { selectedIndex, setSelectedIndex, tabRefs, focusPanel } = this.props.tabs;
      const numTabs = tabRefs.length;
      switch (event.key) {
        case "ArrowRight":
          const nextIndex = selectedIndex != null ? (selectedIndex + 1) % numTabs : 0;
          tabRefs[nextIndex].current?.focus();
          setSelectedIndex(nextIndex);
          break;
        case "ArrowLeft":
          const prevIndex = selectedIndex != null ? (selectedIndex - 1 + numTabs) % numTabs : 0;
          tabRefs[prevIndex].current?.focus();
          setSelectedIndex(prevIndex);
          break;
        case "End":
          const lastIndex = numTabs - 1;
          tabRefs[lastIndex].current?.focus();
          setSelectedIndex(lastIndex);
          break;
        case "Home":
          tabRefs[0].current?.focus();
          setSelectedIndex(0);
          break;
        case "ArrowDown":
          event.preventDefault();
          focusPanel();
          break;
      }
    };
  }
  static {
    this.defaultProps = {
      align: "start" /* Start */
    };
  }
  componentDidMount() {
    this.updateIndicator();
  }
  componentDidUpdate(prevProps) {
    const numTabsChanged = this.props.tabs.tabRefs.length !== prevProps.tabs.tabRefs.length;
    const indexChanged = this.props.tabs.selectedIndex !== prevProps.tabs.selectedIndex;
    if (numTabsChanged || indexChanged) {
      this.updateIndicator();
    }
  }
  render() {
    const { isBordered, align, className, children, tabs, "aria-label": ariaLabel } = this.props;
    const { indicator } = tabs;
    const currentIndicator = indicator?.width ? indicator : this.getIndicatorRect();
    return /* @__PURE__ */ React.createElement(
      "div",
      {
        className: classNames("tabs__tab-list", className, {
          "tabs__tab-list--bordered": isBordered
        })
      },
      /* @__PURE__ */ React.createElement("div", { className: "tabs__tab-list-inner", ref: this.tabListRef, onKeyDown: this.handleKeyDown }, /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, onResize: this.updateIndicator }), !!currentIndicator?.width && /* @__PURE__ */ React.createElement(
        "div",
        {
          className: "tabs__indicator",
          style: {
            transform: `translate3d(${currentIndicator?.left}px, 0, 0)`,
            width: currentIndicator?.width
          }
        }
      ), /* @__PURE__ */ React.createElement(
        "div",
        {
          className: `tabs__tab-list-items tabs__tab-list-items--align-${align}`,
          role: "tablist",
          "aria-orientation": "horizontal",
          "aria-label": ariaLabel
        },
        /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(ReactResizeDetector, { handleWidth: true, onResize: this.updateIndicator }), Children.toArray(children).filter(Boolean).map((child, index) => cloneElement(child, { index })))
      ))
    );
  }
}
export default withTabs(TabList);
